module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0035.jpg?v=c9a05c22";